// // Footer.jsx
// import { FaFacebook, FaInstagram, FaLinkedin, FaTwitter, FaYoutube } from 'react-icons/fa';
// import './Footer.css';

// export default function Footer() {
//   return (
//     <footer className="footer">
//       <div className="footer-container">

//         <div className="footer-section">
//           <h4>News</h4>
//           <ul>
//             <li><a href="#">Press Center</a></li>
//             <li><a href="#">The Lions Blog</a></li>
//             <li><a href="#">LION Magazine</a></li>
//           </ul>
//         </div>

//         <div className="footer-section">
//           <h4>Media</h4>
//           <ul>
//             <li><a href="#">Video Center</a></li>
//             <li><a href="#">Logos</a></li>
//             <li><a href="#">Brand Guidelines</a></li>
//           </ul>
//         </div>

//         <div className="footer-section">
//           <h4>Connect</h4>
//           <ul>
//             <li><a href="#">Careers</a></li>
//             <li><a href="#">Contact LCI</a></li>
//             <li><a href="#">Contact LCIF</a></li>
//             <li><a href="#">Your Privacy</a></li>
//           </ul>
//         </div>

//         <div className="footer-section contact-info">
//           <p>300 W. 22nd Street<br />Oak Brook, IL 60523-8842 USA</p>
//           <p>+1 (630) 571-5466</p>
//         </div>

//         <div className="footer-section">
//           <h4>Also of Interest</h4>
//           <ul>
//             <li><a href="#">LCIF Mission</a></li>
//             <li><a href="#">Find a Local Lions Club</a></li>
//             <li><a href="#">Results</a></li>
//           </ul>
//         </div>

//       </div>
//    <div className="footer-social">
//         <a href="#"><FaFacebook /></a>
//         <a href="#"><FaTwitter /></a>
//         <a href="#"><FaInstagram /></a>
//         <a href="#"><FaLinkedin /></a>
//         <a href="#"><FaYoutube /></a>
//       </div>
//       <div className="footer-bottom">
//         <p>
//           All donations accepted on lionsclubs.org support Lions Clubs International Foundation (LCIF), 
//           a 501(c)(3) tax-exempt public charitable organization. Lions Clubs International (LCI) is a 
//           501(c)(4) tax-exempt social welfare organization and is not eligible to accept or solicit 
//           charitable donations. LCI and LCIF are EEO providers.
//         </p>
//       </div>
//     </footer>
//   );
// }


import { FaFacebook, FaInstagram, FaLinkedin, FaTwitter, FaYoutube } from 'react-icons/fa';
import './Footer.css';
import { translateText } from "../Navbar/Navbar";
import { useEffect, useState } from 'react';

export default function Footer({ selectedLang }) {
  const [translated, setTranslated] = useState({
    News: "News",
    PressCenter: "Press Center",
    LionsBlog: "The Lions Blog",
    LionMagazine: "LION Magazine",
    Media: "Media",
    VideoCenter: "Video Center",
    Logos: "Logos",
    BrandGuidelines: "Brand Guidelines",
    Connect: "Connect",
    Careers: "Careers",
    ContactLCI: "Contact LCI",
    ContactLCIF: "Contact LCIF",
    YourPrivacy: "Your Privacy",
    AlsoOfInterest: "Also of Interest",
    LCIFMission: "LCIF Mission",
    FindLocalLionsClub: "Find a Local Lions Club",
    Results: "Results",
    Address: "300 W. 22nd Street Oak Brook, IL 60523-8842 USA",
    Phone: "+1 (630) 571-5466",
    DonationInfo: "All donations accepted on lionsclubs.org support Lions Clubs International Foundation (LCIF), a 501(c)(3) tax-exempt public charitable organization. Lions Clubs International (LCI) is a 501(c)(4) tax-exempt social welfare organization and is not eligible to accept or solicit charitable donations. LCI and LCIF are EEO providers."
  });

  useEffect(() => {
    const englishTexts = {
      News: "News",
      PressCenter: "Press Center",
      LionsBlog: "The Lions Blog",
      LionMagazine: "LION Magazine",
      Media: "Media",
      VideoCenter: "Video Center",
      Logos: "Logos",
      BrandGuidelines: "Brand Guidelines",
      Connect: "Connect",
      Careers: "Careers",
      ContactLCI: "Contact LCI",
      ContactLCIF: "Contact LCIF",
      YourPrivacy: "Your Privacy",
      AlsoOfInterest: "Also of Interest",
      LCIFMission: "LCIF Mission",
      FindLocalLionsClub: "Find a Local Lions Club",
      Results: "Results",
      Address: "300 W. 22nd Street Oak Brook, IL 60523-8842 USA",
      Phone: "+1 (630) 571-5466",
      DonationInfo: "All donations accepted on lionsclubs.org support Lions Clubs International Foundation (LCIF), a 501(c)(3) tax-exempt public charitable organization. Lions Clubs International (LCI) is a 501(c)(4) tax-exempt social welfare organization and is not eligible to accept or solicit charitable donations. LCI and LCIF are EEO providers."
    };

    async function translateAll() {
      try {
        const translatedTexts = await Promise.all(
          Object.keys(englishTexts).map(async (key) => {
            const translatedText = await translateText(englishTexts[key], selectedLang);
            return { [key]: translatedText };
          })
        );
        const newTranslated = translatedTexts.reduce((acc, item) => ({ ...acc, ...item }), {});
        setTranslated(newTranslated);
      } catch (error) {
        console.error("Translation failed:", error);
      }
    }

    translateAll();
  }, [selectedLang]);

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <h4>{translated.News}</h4>
          <ul>
            <li><a href="#">{translated.PressCenter}</a></li>
            <li><a href="#">{translated.LionsBlog}</a></li>
            <li><a href="#">{translated.LionMagazine}</a></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>{translated.Media}</h4>
          <ul>
            <li><a href="#">{translated.VideoCenter}</a></li>
            <li><a href="#">{translated.Logos}</a></li>
            <li><a href="#">{translated.BrandGuidelines}</a></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>{translated.Connect}</h4>
          <ul>
            <li><a href="#">{translated.Careers}</a></li>
            <li><a href="#">{translated.ContactLCI}</a></li>
            <li><a href="#">{translated.ContactLCIF}</a></li>
            <li><a href="#">{translated.YourPrivacy}</a></li>
          </ul>
        </div>

        <div className="footer-section contact-info">
          <p>{translated.Address}</p>
          <p>{translated.Phone}</p>
        </div>

        <div className="footer-section">
          <h4>{translated.AlsoOfInterest}</h4>
          <ul>
            <li><a href="#">{translated.LCIFMission}</a></li>
            <li><a href="#">{translated.FindLocalLionsClub}</a></li>
            <li><a href="#">{translated.Results}</a></li>
          </ul>
        </div>
      </div>

      <div className="footer-social">
        <a href="https://www.facebook.com/share/1FbtmFtQy7/?mibextid=wwXIfr"><FaFacebook /></a>
        <a href="#"><FaTwitter /></a>
        <a href="https://www.instagram.com/lionsclubs_in?igsh=MWd3bTUyYXc3eHB6NA=="><FaInstagram /></a>
        <a href="https://www.linkedin.com/in/lions-council-of-india-152429324?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app"><FaLinkedin /></a>
        <a href="#"><FaYoutube /></a>
      </div>

      <div className="footer-bottom">
        <p>{translated.DonationInfo}</p>
      </div>
    </footer>
  );
}
